import { CommonModule } from '@angular/common';
import {Component, inject, OnDestroy, OnInit, HostListener} from '@angular/core';
import {ExamService} from "../../data-access/exam.service";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {
  faAdd,
  faChevronDown,
  faChevronUp,
  faMagnifyingGlass,
  faListCheck,
  faPencil,
  faLayerGroup,
  faXmark, faPlus, faTrash,
  faArrowUpRightFromSquare, faFileCirclePlus, faPen, faUserPen, faStopwatch, faFileLines
} from "@fortawesome/free-solid-svg-icons";
import {DropdownMenuComponent, MenuItem} from "../../../shared/ui/dropdown-menu/dropdown-menu.component";
import {Router} from "@angular/router";
import {OutlineButtonComponent} from "../../../shared/ui/outline-button/outline-button.component";
import {DropdownSearchComponent} from "../../../shared/ui/dropdown-search/dropdown-search.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {APIResponse} from "../../../shared/data-access/api-response.model";
import {FormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {FullButtonComponent} from "../../../shared/ui/full-button/full-button.component";
import {ClearButtonComponent} from "../../../shared/ui/clear-button/clear-button.component";
import {Subscription} from "rxjs";
import {AuthService} from "../../../login/data-access/auth.service";
import * as _ from "lodash";
import {UserManagementService} from "../../../admin/data-access/user-management.service";
import {BreadcrumbComponent} from "../../../shared/ui/breadcrumb/breadcrumb.component";
import {toLower} from "lodash";
import {AssessmentTypes} from "../../../student-classroom/assessments/student-classroom-assessments.component";
import {CheckboxCircleComponent} from "../../../shared/ui/icons/checkbox-circle/checkbox-circle.component";
import {TooltipDirective} from "../../../shared/ui/tooltip/tooltip.component";
import {
  FullLengthPaginationComponent
} from "../../../shared/ui/pagination/full-length-pagination/full-length-pagination.component";
import {Pagination} from "../exam-submissions/exam-submissions.component";
import {DotSpinnerComponent} from "../../../shared/ui/loaders/dot-spinner.component";
import { DeleteConfirmationComponent } from "src/app/shared/ui/delete-confirmation/delete-confirmation.component";
import { SearchInputComponent } from "src/app/shared/ui/search-input/search-input.component";

interface Items {
  course_name: string
  unit_id: number
  unit_name: string
  subject_id: number
  subject_name: string
  organization_id: number
  organization_name: string
  earliest_start: Date
  latest_start: Date
  last_finish: Date
  timeframe?: Timeframe
  subsection_names: string
  exam_id: number
  exam_title: string
  type: string
  course_id: number
  attempts_max: number
  graded: boolean
  late_start: number
  late_finish: number
  user_id: number
  open: boolean
  active: boolean
  createdate: Date
  lastupdated: Date
  menuItems: MenuItem[]
  display_name: string
  author_name: string
  isAuthor: boolean
  isEditor: boolean
  isGrader: boolean
}
interface Timeframe {
  first_start?: Date
  last_start?: Date,
  finish_by?: Date,
}
interface ExamResponse {
  limit: number
  size: number
  page: number
  start: number
  totalcount: number
  items: Items[]
}
interface UserResponse {
  name: string
  user_id: number
  username: string
  isSelected: boolean
}
interface Editor {
  display_name: string
  active: boolean
  connection: string
  exam_id: number
  user_id: number
}
enum Tabs{
  my_exams = 'My Exams',
  non_active_exams = 'Non-active Exams',
  active_exams = 'Active Exams',
  opened_exams = 'Opened Exams',
}
@Component({
    selector: 'list-exam',
    templateUrl: './list.component.html',
    styleUrls: ['list.component.css', '../../../student-classroom/assessments/student-classroom-assessments.component.css'],
  imports: [CommonModule, FontAwesomeModule, DropdownMenuComponent, OutlineButtonComponent, DropdownSearchComponent, FormsModule, MatIconModule, FullButtonComponent, ClearButtonComponent, BreadcrumbComponent, CheckboxCircleComponent, TooltipDirective, FullLengthPaginationComponent, FullButtonComponent, DotSpinnerComponent, DeleteConfirmationComponent, SearchInputComponent]
})
export class ListExamComponent implements OnInit, OnDestroy {
  constructor(private _snackBar: MatSnackBar, private usersService: UserManagementService) {}
  examService = inject(ExamService);
  router = inject(Router)
  examResponse!: ExamResponse
  faAdd = faAdd
  faMagnifyingGlass = faMagnifyingGlass
  showOwnerPopup = false
  changeOwnerExamID = -1
  changeOwnerUserID =  ''
  changeOwnerDisplayName = ''
  activeFilter = false
  showDeleteDialog = false
  deleteExamID = -1
  authService = inject(AuthService);
  examCreate = false
  searchIconStyle = `color: ${localStorage.getItem('primaryColor')}; margin-right: 0.5rem; margin-left: 0.5rem; flex-shrink: 1;`
  searchText = ''
  foundUsers: UserResponse[] = []
  examFilter = 'mine'
  currentUserName = ''
  openEditors = false
  showList = false
  currentEditors: Editor[] = []
  editorsToAdd: Editor[] = []
  editorExam = -1
  showDropdown = false
  examSearchText = ''
  examTabs: Tabs = Tabs.my_exams
  showAssessmentTypeDropdown = false
  assessmentTypeSelected = AssessmentTypes.all_types;
  isMobile = false
  openFilterDropdown = false
  openEditTimeDialog = false
  editTimeItem: Items | null = null
  openActionInfoDialog = false
  // This exam admin will track if this user has the privilege to activate exams. Delete exams that they do not own
  examAdmin = false
  exams: Items[] = []
  currentPagination: Pagination = {
    limit: 15,
    size: 0,
    page: 0,
    start: 0,
    totalcount: 0,
    maxpage: 0
  }
  isSearchLoading = false
  is_classroom = false

  userPermissionSub: Subscription = this.authService.userDashboard$.subscribe((user) => {
    this.examAdmin = user.result.some(el => el.ui === 'ExamAdmin')
    this.is_classroom = user.result.some(el => el.ui === 'ClassroomAdmin')
    if(user.result.some(el => el.ui === 'ExamCreate')) {
      this.examCreate = true
    } else {
      this.toggleActiveFilter()
    }
  })

  userSub: Subscription = this.authService.user$.subscribe((user) => {
    this.currentUserName = user.given_name + ' ' + user.family_name
  })

  ngOnInit() {
    this.getMyExams()
  }

  ngOnDestroy() {
    this.userPermissionSub.unsubscribe()
    this.userSub.unsubscribe()
  }

  getExams() {
    this.isSearchLoading = true
    this.examService.listAllExams(this.currentPagination.page, this.currentPagination.limit, this.examSearchText, this.examTabs === this.tabs.active_exams, this.examTabs === this.tabs.opened_exams).subscribe((response) => {
      if(response.success) {
        this.handleSuccessListExams(response)
        this.currentPagination.totalcount = response.totalcount
        this.currentPagination.size = response.result.length
      }
      else if(response.msg === 'no exams found') {
        this.examResponse = {
          ...response.result,
          items: []
        }
      }
      this.isSearchLoading = false
    })
  }

  getMyExams() {
    this.isSearchLoading = true
    this.examService.listMyExams(this.currentPagination.page, this.currentPagination.limit, this.examSearchText, this.examTabs === this.tabs.active_exams, this.examTabs === this.tabs.opened_exams).subscribe((response) => {
      if(response.success) {
        this.handleSuccessListExams(response)
        this.currentPagination.totalcount = response.totalcount
        this.currentPagination.size = response.result.length
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar'], duration: 3000})
      }
      this.isSearchLoading = false
    })
  }

  onBlur() {
    this.showList = false
  }

  onFocus() {
    this.showList = true
  }

  addToAddEditorList(user: UserResponse) {
    this.editorsToAdd.push({active: true ,connection: 'Editor',exam_id: this.editorExam,user_id: user.user_id, display_name: user.name })
    this.showList = false
  }

  addEditor(editor: Editor) {
    this.examService.addExamEditor(this.editorExam, editor.user_id).subscribe((response) => {
      if(response.success) {
        this.currentEditors.unshift(editor)
        this.editorsToAdd = this.editorsToAdd.filter(obj => obj.user_id !== editor.user_id)
        this._snackBar.open('Editor successfully added', 'Dismiss', {duration: 3000})
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar'], duration: 3000})
      }
    })
  }

  removeEditor(editor: Editor) {
    this.examService.removeExamEditor(this.editorExam, editor.user_id).subscribe((response) => {
      if(response.success) {
        this.currentEditors = this.currentEditors.filter(obj => obj.user_id !== editor.user_id)
        this._snackBar.open('Editor successfully removed', 'Dismiss', {duration: 3000})
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar'], duration: 3000})
      }
    })
  }

  handleSuccessListExams(response: APIResponse) {
    this.examResponse = {
      ...response.result,
      items: []
    }
    for(let item of response.result) {
      const menuItems: MenuItem[] = []
      const examItem = {
        ...item,
        menuItems: menuItems
      }

      if (this.examAdmin || item.isAuthor || item.isGrader) {
        menuItems.push({ title: 'Export', icon: faArrowUpRightFromSquare, action: () => this.exportExam(item.exam_id) })
      }
      if (this.examAdmin || item.isAuthor) {
        menuItems.push({ title: 'Add Graders', icon: faFileCirclePlus, action: () => this.addGraders(item.exam_id, item.course_id) })
      }
      if (item.isAuthor) {
        menuItems.push({ title: 'Editors', icon: faPen, action: () => this.examEditors(item.exam_id) })
      }
      if (this.examAdmin || item.isAuthor) {
        menuItems.push({ title: 'Edit Owner', icon: faUserPen, action: () => this.editOwner(item.exam_id, item.author_name) })
      }
      if (this.examAdmin) {
        menuItems.push({ title: 'Edit Time', icon: faStopwatch, action: () => this.editTime(examItem) })
      }
      if (this.examAdmin || item.isAuthor || item.isGrader) {
        menuItems.push({ title: 'Instances', icon: faFileLines, action: () => this.navigateToExamInstances(item.exam_id, item.exam_title) })
      }

      this.examResponse.items.push(examItem)

      this.exams = this.examResponse.items
    }
  }

  saveOwnerChange(force?: boolean) {
    // TODO find user that isSelected in found users
    for(let user of this.foundUsers) {
      if(user.isSelected)
        this.changeOwnerUserID = user.user_id.toString()
    }
    if(this.changeOwnerExamID !== -1  && this.changeOwnerUserID !== '') {
      this.examService.changeExamOwner(this.changeOwnerExamID, parseInt(this.changeOwnerUserID), force).subscribe((response) => {
        if(response.success) {
          //TODO on success close the popup and call snackbar
          this.getMyExams()
          this._snackBar.open('Exam Owner Changed Successfully', 'Dismiss', {duration: 3000})
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar'], duration: 3000})
        }
      })
      this.changeOwnerUserID = ''
      this.changeOwnerExamID = -1
      this.showOwnerPopup = false
    }
  }

  cancelOwnerChange() {
    this.changeOwnerUserID = ''
    this.changeOwnerExamID = -1
    this.showOwnerPopup = false
  }

  toggleActiveFilter() {
    this.activeFilter  = !this.activeFilter
    if(this.activeFilter) {
      this.examService.listActiveExams(true, true).subscribe((response) => {
        if(response.success)
          this.handleSuccessListExams(response)
        else if(response.msg === 'no exams found') {
          this.examResponse = {
            ...response.result,
            items: []
          }
        }
      })
    } else {
      this.examService.listAdminExam().subscribe((response) => {
        if(response.success)
          this.handleSuccessListExams(response)
        else if(response.msg === 'no exams found') {
          this.examResponse = {
            ...response.result,
            items: []
          }
        }
      })
    }
  }

  previewExam(exam_id: number) {
    this.router.navigate(['dashboard/exam/preview'], {queryParams: {exam_id: exam_id, part: 0}});
  }

  editExam(exam_id: number) {
    this.router.navigate(['dashboard/exam/create'], {queryParams: {edit: true, exam_id: exam_id}})
  }

  navigateToExamInstances(exam_id: number, exam_title: string) {
    this.router.navigate(['dashboard/exam/instances'], {queryParams: {exam_id: exam_id, exam_title: exam_title}})
  }

  cloneExam(exam_id: number) {
    this.router.navigate(['dashboard/exam/create'], {queryParams: {clone: true, exam_id: exam_id}})
  }

  exportExam(exam_id: number) {
    this.router.navigate(['dashboard/exam/export/list'], {queryParams: {exam_id: exam_id}})
  }

  addGraders(exam_id: number, course_id: number) {
    this.router.navigate(['dashboard/exam/graders'], {queryParams: {exam_id: exam_id, course_id: course_id}})
  }

  handlePaginationChange() {
    console.log(this.currentPagination)
    if(this.examTabs === this.tabs.my_exams) {
      this.getMyExams()
    } else {
      this.getExams()
    }
  }

  examEditors(exam_id: number) {
    this.openEditors = true
    this.searchText = ''
    this.foundUsers = []
    this.currentEditors = []
    this.editorsToAdd = []
    this.editorExam = exam_id
    this.examService.listExamEditors(exam_id).subscribe((response) => {
      if(response.success) {
        this.currentEditors = response.result
      } else {
        // TODO handle error/empty list
      }
    })
  }

  editOwner(exam_id: number, display_name: string) {
    this.changeOwnerDisplayName = display_name
    this.changeOwnerExamID = exam_id
    this.showOwnerPopup = true
    this.searchText = ''
    this.foundUsers = []
  }

  cancelDelete() {
    this.showDeleteDialog = false
    this.deleteExamID = -1
  }

  confirmDelete() {
    this.examService.deleteExam(this.deleteExamID).subscribe((response) => {
      if(response.success) {
        this._snackBar.open('Exam successfully deleted', 'Dismiss', {duration: 3000})
        if(this.examTabs === this.tabs.my_exams) {
          this.getMyExams()
        } else {
          this.getExams()
        }
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar'], duration: 3000})
      }
      this.cancelDelete()
    })
  }

  debounceExamSearch = _.debounce(() => {
    this.isSearchLoading = true
    if(this.examTabs === this.tabs.my_exams) {
      this.getMyExams()
    } else {
      this.getExams()
    }
  }, 500)

  debounceSearch = _.debounce(() => {
    this.usersService.searchUsers(this.searchText, 0, 10).subscribe((response) => {
      if(response.success) {
        this.foundUsers = []
        for(let user of response.result.items) {
          this.foundUsers.push({
            name: user.display_name,
            user_id: user.user_id,
            username: user.username,
            isSelected: false
          })
        }
        this.showDropdown = true
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar'], duration: 3000})
      }
    })
  }, 500)

  selectUser(index: number) {
    for(let item of this.foundUsers) {
      item.isSelected = false
    }
    this.foundUsers[index].isSelected = true
    this.searchText = this.foundUsers[index].name
    this.showDropdown = false;
  }

  @HostListener('click') onClick() {
    this.showDropdown = false
  }

  switchToMyExams() {
    this.examFilter = 'mine'
    this.examTabs = this.tabs.my_exams
    this.activeFilter = false
    this.currentPagination.page = 0
    this.getMyExams()
  }

  switchToNonActiveExams() {
    this.examFilter = 'not-active'
    this.examTabs = this.tabs.non_active_exams
    this.activeFilter = false
    this.currentPagination.page = 0
    this.getExams()
  }

  switchToActiveExams() {
    this.examFilter = 'active'
    this.activeFilter = true
    this.examTabs = this.tabs.active_exams
    this.currentPagination.page = 0
    this.getExams()
  }

  switchToOpenExams() {
    this.examFilter = 'open'
    this.activeFilter = true
    this.examTabs = this.tabs.opened_exams
    this.currentPagination.page = 0
    this.getExams()
  }

  toggleActivateExam(exam: Items, active: boolean) {
    this.examService.activateExam(exam.exam_id, active).subscribe((response) => {
      if(response.success) {
        if(!active)
          this._snackBar.open('Exam deactivated', 'Dismiss', {duration: 3000})
        else
          this._snackBar.open('Exam activated', 'Dismiss', {duration: 3000})
        if(this.examTabs === this.tabs.my_exams) {
          this.getMyExams()
        } else {
          this.getExams()
        }
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar'], duration: 3000})
      }
    })
  }

  openExam(exam_id: number, active: boolean, open: boolean) {
    if (active) {
      this.examService.openExam(exam_id, open).subscribe((response) => {
        if(response.success) {
          open == false ? this._snackBar.open('Exam closed', 'Dismiss', {duration: 3000}) : this._snackBar.open('Exam opened', 'Dismiss', {duration: 3000})
          if(this.examTabs === this.tabs.my_exams) {
            this.getMyExams()
          } else {
            this.getExams()
          }
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar'], duration: 3000} )
        }
      })
    } else {
      this._snackBar.open('Exam must be active to be opened', 'Dismiss', {panelClass: ['error-snackbar'], duration: 3000} )
    }
  }

  openDeleteExamDialog(exam_id: number) {
    this.showDeleteDialog = true
    this.deleteExamID = exam_id
  }

  switchAssessmentTypeSelected(type: AssessmentTypes) {
    this.assessmentTypeSelected = type;
    switch(type) {
      case(AssessmentTypes.all_types):
        // TODO filter based on type here
        break;
      case(AssessmentTypes.exam):
        break;
      case(AssessmentTypes.quiz):
        break;
      case(AssessmentTypes.homework):
    }
    this.showAssessmentTypeDropdown = false
  }

  filterExams(): Items[] {
    return this.examResponse.items.filter(i => i.exam_title.toLowerCase().includes(this.examSearchText.toLowerCase()))
  }

  editTime(item: Items) {
    this.openEditTimeDialog = true
    this.editTimeItem = item
  }

  saveEditExamTime() {
    // TODO latest_start is not a thing with these new endpoints
    if(this.editTimeItem && this.editTimeItem.exam_id != null && this.editTimeItem.latest_start != null && this.editTimeItem.last_finish != null) {
      this.examService.updateExamTime(this.editTimeItem.exam_id, this.editTimeItem.latest_start, this.editTimeItem.last_finish).subscribe((response) => {
        if(response.success) {
          this.openEditTimeDialog = false
          this._snackBar.open('Exam time updated', 'Dismiss', {duration: 3000})
          if(this.examTabs === this.tabs.my_exams) {
            this.getMyExams()
          } else {
            this.getExams()
          }
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar'], duration: 3000} )
        }
      })
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.screen.width <= 768;
  }

  protected readonly faChevronDown = faChevronDown;
  protected readonly faChevronUp = faChevronUp;
  protected readonly faXmark = faXmark;
  protected readonly faPlus = faPlus;
  protected readonly faTrash = faTrash;
  protected readonly toLower = toLower;
  tabs = Tabs;
  AssessmentTypes = AssessmentTypes;
}
